/* tslint:disable */

declare var Object: any;
export interface ResponseInterface {
  "userId": number;
  "questionId": number;
  "companyId": number;
  "value"?: string;
  "id"?: number;
}

export class Response implements ResponseInterface {
  "userId": number;
  "questionId": number;
  "companyId": number;
  "value": string;
  "id": number;
  constructor(data?: ResponseInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Response`.
   */
  public static getModelName() {
    return "Response";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Response for dynamic purposes.
  **/
  public static factory(data: ResponseInterface): Response{
    return new Response(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Response',
      plural: 'Responses',
      path: 'Responses',
      idName: 'id',
      properties: {
        "userId": {
          name: 'userId',
          type: 'number'
        },
        "questionId": {
          name: 'questionId',
          type: 'number'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "value": {
          name: 'value',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
